<ui-section>
  <ui-block [width]="addActFormValues.width">
    <ui-panel panelTitle="{{notableRole}}" [width]="addActFormValues.width"

      [(additionalActionsFormValues)]="addActFormValues"

      [panelHeaderConfig]="panelHeaderConfig"
      (buttonClick)="onPanelHeaderButtonClick($event)"
    >

      <ui-form [config]="actorInfoInputsConfig" #dynaForm
        [(formValues)]="formValues"
        (formValuesChange)="formValuesChange($event)"
        [idFieldname]="'id'"
        (formValuesDelta)="delta = stripMetadata($event)"
        [disabled]="isDisabled"
        [saveEndpoint]="'mock/StarWarsActors/{id}'"
        [useAutoSave]="true"
        [apiOptions]="{feedbackOptions:{successMode:'greenCheckmarks'}}"
        (autoCompleteCompleted)="onAutoCompleteCompleted($event)"
      >
        <!-- This is how you specify a custom item template for a particular Autocomplete control -->
        <!-- <ng-template ezAutoCompleteItem="otherChar" let-item>
          <div class="p-2">
            <strong>Role:</strong> {{ item?.notableRole }}
          </div>
        </ng-template> -->

      </ui-form>
    </ui-panel>
  </ui-block>

  <ui-block width="2x">
    <ui-panel panelTitle="formValues">
      <pre><code [highlightChange]="friendlyFormValues | json" [highlightChangeWordBoundaries]="true"></code></pre>
    </ui-panel>
  </ui-block>

  <ui-block width="2x" class="left flex flex-column">
    <ui-panel panelTitle="Controls">
      <markdown>
        This sample uses `useAutoSave=true`, so changes save automatically. The Update button triggers an explicit manual save.
      </markdown>
      <div class="flex ui-gap">
          <ui-button (click)="isDisabled = !isDisabled"> Toggle Disabled</ui-button>
          <ui-button (click)="dynaForm.UpdateForm()">Update</ui-button>
      </div>
      <!--
        Example of binding to the formsValues property which will
        automatically propogate to/from the form in both directions.
        This <input> element knows nothing of the form.
      -->
      <div>First Name: <input [ngModel]="formValues?.['firstName']" (ngModelChange)="formValues = formValues || {}; formValues['firstName'] = $event"/></div>

      <!-- This is NOT automatically bound. If you want to bind to a single variable, create a get/set for the variable-->
      <!-- <div>Last Name: <b>{{lastName}}</b> (not bound, won't auto update)</div> -->
      <div>Notable Role: <b>{{notableRole}}</b> (bound with get/set)</div>
      <div>formValuesDelta: <b>{{delta | json}}</b></div>
    </ui-panel>
  </ui-block>
</ui-section>
